import { CommissionModel } from 'api-hooks/commission';
import { SaleDepartmentEnum } from 'common/constants/enum';
import { generateId } from 'common/utils/string';
import dayjs from 'dayjs';
import React from 'react';

import {
  CommissionDetailFormType,
  CommissionFormType,
} from '../components/form-type';

export function onAddNewCommissionDetail(): CommissionDetailFormType {
  return {
    type: 'fixed',
    adminCommission: undefined,
    operatorCommission: undefined,
    salesCommission: undefined,
    commissionable: '',
    customId: generateId(),
  } as unknown as CommissionDetailFormType;
}

export default function useGetDefaultValues(commission?: CommissionModel) {
  const defaultValues = React.useMemo<CommissionFormType>(() => {
    const startOfDay = dayjs().startOf('day').toDate();
    return {
      appliedOn: commission?.appliedOn || startOfDay,
      commissionMasterAdditionals:
        commission?.department !== SaleDepartmentEnum.Product
          ? commission?.commissionMasterAdditionals?.map((detail) => {
              const commissionable =
                typeof detail.commissionable === 'object'
                  ? detail.commissionable.id
                  : detail.commissionable;

              return {
                id: detail.id,
                leadCommission: detail.leadCommission,
                customId: generateId(),
                operatorSalesCommission: detail.operatorSalesCommission,
                type: detail.type,
                commissionable,
              };
            }) || [onAddNewCommissionDetail()]
          : [],
      department: commission?.department || SaleDepartmentEnum.Flight,
      hasBaseCommission: commission?.hasBaseCommission || true,
      leadCommission: commission?.leadCommission || null,
      operatorSalesCommission: commission?.operatorSalesCommission || null,
      type: commission?.type || null,
      commission,
    };
  }, [commission]);

  return defaultValues;
}
